import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface HomeTypesParams extends DefaultHttpHeaders {}

@Injectable()
export class HomeTypesService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining home types
   * Service for obtaining home types
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundHomeTypes
   */
  homeTypes(params: HomeTypesParams): Observable<ParameterResult[]> {
    return this.get<ParameterResult[]>({
      suffix: '/comeround/catalog/homeTypes',
    });
  }
}
